import { format } from 'date-fns'


export default  function generateCutoff(dateFrom, dateTo) {
    if (!dateFrom || !dateTo) return ''
    const from = new Date(dateFrom)
    const to = new Date(dateTo)

    const month = format(from, 'MMMM')
    const year = format(to, 'yyyy')
    const fromDay = from.getDate()
    const toDay = to.getDate()

    if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
        return `${format(from, 'MMMM')} ${fromDay}-${toDay}, ${year}`
    }

    const monthFrom = format(from, 'MMMM')
    const monthTo = format(to, 'MMMM')
    return `${monthFrom} ${fromDay} - ${monthTo} ${toDay}, ${year}`

}
